import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { connect } from 'react-redux';
import omit from 'lodash/omit';
import isEmpty from 'lodash/isEmpty';

import Tab from '../../../components/Tab';
import Modal from '../../../components/Modal';
import Button from '../../../components/Button';
import RouteTransitionPrompt from '../../../components/RouteTransitionPrompt';
import SubscriptionUpgradeForm from '../../SubscriptionUpgradeForm';

import messages from '../messages';
import MediaPage from '../Edit/tabsContent/mediaPage';
import EditLogoModal from '../Edit/editLogoModal';
import EditPhotosAndVideosModal from '../Edit/editPhotosAndVideosModal';
import EditAboutUsModal from '../Edit/editAboutUsModal';
import AddLinkModal from '../Edit/addLinkModal';
import AddProfileModal from '../Edit/editProfile/addProfileModal';
import PublishConfirmationModal from '../Edit/publishConfirmationModal';
import Intro from '../Edit/tabsContent/Intro';
import LinksAndProfiles from '../Edit/tabsContent/LinksAndProfiles';
import PremiumPublishButton from '../Edit/PremiumMenu/premiumPublishButton';
import ErrorModal from '../errorModal/publishErrorModal';
import {
  resetNonPersistentCollegeProfile,
  resetIntroChangesFlag,
  resetMediaChangesFlag,
  resetLinksAndProfilesChangesFlag,
  initializeCMSData,
} from '../actions';

import getCollegeService from '../hemServices/get-college-service';
import { getValidationErrors } from '../BasicInfo/validators';
import contentTypes from './content-types.json';

import '../styles.css';

import BasicInfoMenu from '../BasicInfo';
import MenuHeader from '../BasicInfo/MenuHeader';
import IntroMenu from './IntroMenu';
import MediaMenu from './MediaMenu';
import LinksAndProfilesMenu from './LinksAndProfilesMenu';
import HubsReact from '../viewReact';
import BasicInfoToHubsMapper from '../basicInfoToHubs';
import Loading from '../Loading';
import {
  BASIC_INFO_TAB,
  INTRO_TAB,
  MEDIA_TAB,
  LINKS_AND_PROFILES_TAB,
  DEFAULT_CONTENT_TYPE,
  CAMINO_CONTENT_TYPE,
} from '../constants';
import CaminoPreviewPane from '../CaminoPreviewPane/index';
import { FEATURE_MATCH_HUBS_INTERSECT_YOUVISITTOURS_IPEDSCODE } from '../../Authorization/constants';
import { withEnabledFeatures } from '../../../utils/features';

export const NoContent = () => <div id="no-tab">Not tab selected</div>;

export const InvalidDataModal = ({ onCancel, errors }) => (
  <Modal open size="small">
    <div styleName="hubs-modal invalid-data">
      <div styleName="submit-overlay__content">
        <h2 styleName="submit-overlay__title">Errors in the data!</h2>
        <p styleName="submit-overlay__message">The changes you have made contain invalid data.  Please edit and try again.</p>
        {errors && errors.length > 0 && (
          <ul>
            {errors.map((error) => (
              <li key={error.label}>
                <p styleName="submit-overlay__list">{error.errorPath.map((path, i) => (
                  <React.Fragment>
                    {i > 0 && (<span> - </span>)}
                    {typeof path === 'string' && <span>{path}</span>}
                    {typeof path === 'object' && <FormattedMessage {...path} />}
                  </React.Fragment>
                ))}
                </p>
              </li>
            ))}
          </ul>
        )}
        <div styleName="submit-overlay__buttons">
          <Button secondary onClick={onCancel}>Continue editing</Button>
        </div>
      </div>
    </div>
  </Modal>
);
InvalidDataModal.propTypes = {
  onCancel: PropTypes.func,
  errors: PropTypes.array,
};

export const BasicInfoOopsModal = ({ onCancel, onSubmit }) => (
  <Modal open size="small">
    <div styleName="hubs-modal oops">
      <div styleName="submit-overlay__content">
        <h2 styleName="submit-overlay__title">Ooops, something went wrong.</h2>
        <p styleName="submit-overlay__message">We&apos;re sorry, but your updates didn&apos;t go through. Please try again.</p>
        <div styleName="submit-overlay__buttons">
          <Button onClick={onCancel}>Cancel and continue editing</Button>
          <span styleName="submit-overlay__buttons-or">or</span>
          <Button secondary onClick={onSubmit}>Submit Changes</Button>
        </div>
      </div>
    </div>
  </Modal>
);
BasicInfoOopsModal.propTypes = {
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
};

export class PremiumMenuComponent extends React.Component {
  static propTypes = {
    logoUpload: PropTypes.func.isRequired,
    photoUpload: PropTypes.func.isRequired,
    scid: PropTypes.string.isRequired,
    collegeName: PropTypes.string.isRequired,
    linksAndProfilesChanges: PropTypes.object,
    mediaChanges: PropTypes.object,
    updateHubsCollegeLogo: PropTypes.func,
    updateHubsWebTour: PropTypes.func,
    updateHubsWebLinks: PropTypes.func,
    updateHubsProfiles: PropTypes.func,
    updateHubsSchoolProfiles: PropTypes.func,
    nextLinkOrder: PropTypes.number,
    resetNonPersistentCollegeProfile: PropTypes.func.isRequired,
    resetIntroChangesFlag: PropTypes.func.isRequired,
    resetMediaChangesFlag: PropTypes.func.isRequired,
    resetLinksAndProfilesChangesFlag: PropTypes.func.isRequired,
    initializeCMSData: PropTypes.func.isRequired,
    introChanges: PropTypes.object,
    basicInfo: PropTypes.object,
    isBasicInfoDataLoaded: PropTypes.bool,
    hasBasicInfoChanges: PropTypes.bool,
    profilePhotoUpload: PropTypes.func,
    hubsCustomProfiles: PropTypes.array,
    hubsWebTour: PropTypes.object,
    hubsWebLinks: PropTypes.object,
    route: PropTypes.object,
    enabledFeatures: PropTypes.array,
  };

  state = {
    showConfirmationModal: false,
    initialConfirmationStep: 1,
    activeTabIndex: 0,
    nextActiveTabIndex: 0,
    menuItems: [BASIC_INFO_TAB, INTRO_TAB, MEDIA_TAB, LINKS_AND_PROFILES_TAB],
    isUpgradeFormVisible: false,
    showEditLogoModal: false,
    showEditPhotosAndVideosModal: false,
    showAddLinkModal: false,
    showAddProfileModal: false,
    showErrorModal: false,
    showNestedMenuType: '',
    validationErrorList: [],
    showBasicInfoOopsModal: false,
    basicInfoContentType: DEFAULT_CONTENT_TYPE,
  };

  constructor(props) {
    super(props);
    this.props.initializeCMSData({
      data: {
        cmsRawData: null,
      },
      isInvalid: true,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.activeTabIndex !== this.state.activeTabIndex) {
      this.resetMenuAndContent();
    }
  }

  onCloseModal = () => {
    const { activeTabIndex } = this.state;
    this.setState({
      showConfirmationModal: false,
      nextActiveTabIndex: activeTabIndex,
    });
  };

  onSubmitModal = async () => {
    const { activeTabIndex, menuItems } = this.state;
    const { linksAndProfilesChanges, mediaChanges, introChanges, hasBasicInfoChanges } = this.props;
    const currentTab = menuItems[activeTabIndex];
    const isBasicInfo = currentTab === BASIC_INFO_TAB && hasBasicInfoChanges;
    try {
      /* istanbul ignore next */
      if (isBasicInfo) {
        await this.submitBasicInfoChanges();
      } else if (
        currentTab === INTRO_TAB &&
        introChanges.hasRegisteredChanges
      ) {
        await this.submitIntroChanges();
        this.props.resetIntroChangesFlag();
      } else if (
        currentTab === MEDIA_TAB &&
        mediaChanges.hasRegisteredChanges
      ) {
        await this.submitMediaChanges();
        this.props.resetMediaChangesFlag();
      } else if (
        currentTab === LINKS_AND_PROFILES_TAB &&
        linksAndProfilesChanges.hasRegisteredChanges
      ) {
        await this.submitLinksAndProfilesChanges();
      }
      this.setState({ showConfirmationModal: true, initialConfirmationStep: 4 });
      this.handleOnContinue();
    } catch (e) {
      if (isBasicInfo) {
        this.setState({ showBasicInfoOopsModal: true });
      } else {
        this.setState({ showErrorModal: true });
      }
    }
  };

  onTabSelection = (e, { activeIndex }) => {
    const { linksAndProfilesChanges, mediaChanges, introChanges, hasBasicInfoChanges } = this.props;
    if (
      get(linksAndProfilesChanges, 'hasRegisteredChanges') ||
      get(mediaChanges, 'hasRegisteredChanges') ||
      get(introChanges, 'hasRegisteredChanges') ||
      hasBasicInfoChanges
    ) {
      this.setState({ showConfirmationModal: true, initialConfirmationStep: 1, nextActiveTabIndex: activeIndex });
      e.preventDefault();
    } else {
      this.setState({
        activeTabIndex: activeIndex,
        nextActiveTabIndex: activeIndex,
      });
    }
  };

  onShowEditLogoModal = () => {
    this.setState({
      showEditLogoModal: true,
    });
  };

  onCloseEditLogoModal = () => {
    this.setState({
      showEditLogoModal: false,
    });
  };

  onShowEditPhotosAndVideosModal = () => {
    this.setState({
      showEditPhotosAndVideosModal: true,
    });
  };

  onCloseEditPhotosAndVideosModal = () => {
    this.setState({
      showEditPhotosAndVideosModal: false,
    });
  };

  onShowEditAboutUsModal = () => {
    this.setState({
      showEditAboutUsModal: true,
    });
  };

  onCloseEditAboutUsModal = () => {
    this.setState({
      showEditAboutUsModal: false,
    });
  };

  onShowAddLinkModal = () => {
    this.setState({
      showAddLinkModal: true,
    });
  };

  onCloseAddLinkModal = () => {
    this.setState({
      showAddLinkModal: false,
    });
  };

  onShowAddProfileModal = () => {
    this.setState({
      showAddProfileModal: true,
    });
  };

  onCloseAddProfileModal = () => {
    this.setState({
      showAddProfileModal: false,
    });
  };

  onCloseErrorModal = () => {
    this.setState({
      showErrorModal: false,
      showConfirmationModal: false,
    });
  };

  handleDisregardMyChanges = () => {
    this.updateTab();
    this.props.resetNonPersistentCollegeProfile();
    this.setState({ showConfirmationModal: false });
  };

  handleOnContinue = () => {
    this.updateTab();
  };

  updateTab = () => {
    const { nextActiveTabIndex } = this.state;
    this.setState({
      activeTabIndex: nextActiveTabIndex,
      showErrorModal: false,
    });
  };

  // puts the correct order value in each link
  adjustLinksOrder = (links) =>
    links.map((link, idx) => ({ ...link, order: idx }));

  /**
   * We only call submitMediaChanges if hasRegisteredChanges
   */
  submitLinksAndProfilesChanges = async () => {
    const {
      linksAndProfilesChanges,
      updateHubsWebLinks,
      updateHubsProfiles,
    } = this.props;
    let links = [];
    const areNewFlags = {};
    const {
      hasLinkUpdates,
      requestInformationLink,
      applyOnlineLink,
      learnMoreLinks,
      areNewLinks,
      hasProfileUpdates,
      customProfiles,
      areNewProfiles,
    } = linksAndProfilesChanges;

    /* istanbul ignore else */
    if (hasLinkUpdates) {
      if (!isEmpty(requestInformationLink) && requestInformationLink.url !== '') {
        links.push(omit(requestInformationLink, 'isUrlInvalid'));
      }
      if (!isEmpty(applyOnlineLink) && applyOnlineLink.url !== '') {
        links.push(omit(applyOnlineLink, 'isUrlInvalid'));
      }
      if (learnMoreLinks) {
        links = links.concat(learnMoreLinks.map((lmLink) => omit(lmLink, 'isUrlInvalid')));
      }
      links = this.adjustLinksOrder(links);

      await updateHubsWebLinks({
        variables: {
          input: {
            createNew: areNewLinks, // this flag is used when we are creating a new set of links createNew = true
            premium_links: links,
          },
        },
      });
      // we need to tell state that we no longer have new links after publishing
      areNewFlags.areNewLinks = false;
    }

    if (hasProfileUpdates) {
      const scannedPhotos = get(
        linksAndProfilesChanges,
        'draftImagesData.scannedPhotoUrls',
        {},
      );

      const profilesToSend = customProfiles
        .map((profile, index) => ({
          ...omit(profile, ['__typename', 'imgDisplayUrl', 'logoDisplayUrl']),
          img: scannedPhotos[index] || profile.img,
        }));

      await updateHubsProfiles({
        variables: {
          input: {
            createNew: areNewProfiles,
            custom_profiles: profilesToSend,
          },
        },
      });
      // we need to tell state that we no longer have new profiles after publishing
      areNewFlags.areNewProfiles = false;
    }

    this.props.resetLinksAndProfilesChangesFlag({ ...areNewFlags });
  };

  /**
   * We only call submitMediaChanges if hasRegisteredChanges
   */
  submitMediaChanges = async () => {
    const {
      mediaChanges,
      updateHubsWebTour,
      updateHubsCollegeLogo,
    } = this.props;
    const {
      media,
      hasMediaUpdates,
      isNewMedia,
      productId,
      s3ScannedURI,
    } = mediaChanges;

    /* istanbul ignore else */
    if (media && hasMediaUpdates) {
      let assets = media;
      // get only the assets' objects with data
      assets = assets.filter((a) => a.media_url);

      // remove uneeded fields from assets' objects
      assets = assets.map((a) =>
        omit(a, [
          'file',
          'croppedImageBlob',
          'mediaDisplayUrl',
          'isValid',
          '__typename',
        ]));

      await updateHubsWebTour({
        variables: {
          input: {
            createNew: isNewMedia,
            campus_media: {
              active: true,
              date_from: Math.floor(Date.now() / 1000),
              date_to: Math.floor(Date.now() / 1000),
              product_id: productId,
              assets,
            },
          },
        },
      });
    }
    /* istanbul ignore else */
    // we only save logo when there is a logo update
    if (s3ScannedURI) {
      await updateHubsCollegeLogo({
        variables: {
          input: {
            createNew: true,
            college_logo: {
              logoUri: s3ScannedURI,
            },
          },
        },
      });
    }
  };

  submitIntroChanges = async () => {
    const { introChanges, updateHubsSchoolProfiles } = this.props;
    const isDelete = get(introChanges, 'delete', false);
    const createNew = isDelete ? false : !get(introChanges.aboutUsData, 'type');
    const newAboutUs = {
      ...omit(introChanges.aboutUsData, '__typename'),
      type: 'school',
    };

    /* istanbul ignore else */
    if (introChanges.draftImageData.scannedPhotoUrl) {
      newAboutUs.img = introChanges.draftImageData.scannedPhotoUrl;
    }

    /* istanbul ignore else */
    if (isDelete) {
      newAboutUs.delete = true;
    }

    await updateHubsSchoolProfiles({
      variables: {
        input: {
          createNew,
          ...newAboutUs,
        },
      },
    });
  };

  submitBasicInfoChanges = /* istanbul ignore next */ async () => {
    const { hasBasicInfoChanges } = this.props;
    /* istanbul ignore else */
    if (hasBasicInfoChanges) {
      const collegeService = getCollegeService();
      /* istanbul ignore else */
      if (collegeService) {
        await collegeService.save();
      }
    }
  };

  toggleUpgradeFormVisibility = () =>
    this.setState((previousState) => ({
      isUpgradeFormVisible: !previousState.isUpgradeFormVisible,
    }));

  showPublishModal = () => {
    const { activeTabIndex, menuItems } = this.state;
    const currentTab = menuItems[activeTabIndex];
    let showConfirmationModal = true;

    /* istanbul ignore else */
    if (currentTab === BASIC_INFO_TAB) {
      showConfirmationModal = false;

      const errors = getValidationErrors(this.props.basicInfo);
      this.setState({ validationErrorList: errors });
      if (errors.length === 0) {
        this.saveBasicInfo();
      }
    }

    /* istanbul ignore else */
    if (showConfirmationModal) {
      this.setState({ showConfirmationModal, initialConfirmationStep: 2 });
    }
  };

  saveBasicInfo = () => {
    const collegeService = getCollegeService();

    if (collegeService) {
      collegeService.removePendingEntities();

      if (collegeService.getChangedContentTypesRequiringApproval().length === 0) {
        this.setState({ showConfirmationModal: true, initialConfirmationStep: 3 });
      } else {
        this.setState({ showConfirmationModal: true, initialConfirmationStep: 2 });
      }
    } else {
      this.setState({ showBasicInfoOopsModal: true });
    }
  };

  handleMenuSelectItem = ({ menuType, contentType = DEFAULT_CONTENT_TYPE }) => {
    /* istanbul ignore else */
    if (menuType && contentType) {
      this.setState({ showNestedMenuType: menuType, basicInfoContentType: contentType });
    }
  };

  resetMenuAndContent = () => {
    this.setState({ showNestedMenuType: '', basicInfoContentType: DEFAULT_CONTENT_TYPE });
  };

  cancelInvalidDataModal = () => {
    this.setState({ validationErrorList: [] });
  };

  cancelBasicInfoOopsModal = () => {
    this.setState({ showBasicInfoOopsModal: false });
  };

  submitAfterBasicInfoOops = () => {
    this.setState({ showBasicInfoOopsModal: false }, () => this.saveBasicInfo());
  };

  getItemsRequiringApproval = () => {
    const collegeService = getCollegeService();

    if (collegeService) {
      return collegeService.getChangedContentTypesRequiringApproval().map((t) => contentTypes[t]);
    }

    return [];
  };

  renderContent = () => {
    if (!this.props.isBasicInfoDataLoaded) {
      return <Loading />;
    }

    const collegeService = getCollegeService();
    const collegeName = get(this.props, 'collegeName', '');
    const { menuItems, activeTabIndex, basicInfoContentType } = this.state;
    const isCamino = basicInfoContentType === CAMINO_CONTENT_TYPE;

    const editData = {
      webLink: this.props.hubsWebLinks,
      webTour: this.props.hubsWebTour,
      profile: { custom_profiles: this.props.hubsCustomProfiles },
      logo: null,
      name: collegeName,
    };
    /* istanbul ignore else */
    if (collegeService && collegeService.cmsDataState === 'LOADED') {
      editData.virtualTour = collegeService.esData.virtualTour;
      editData.fullProfile = { ...BasicInfoToHubsMapper(collegeName, this.props.basicInfo, collegeService) };
      editData.fullProfile.majors = collegeService.esData.fullProfile.majors;
      editData.fullProfile.field_he_minors_ref = collegeService.esData.fullProfile.field_he_minors_ref;
      editData.fullProfile.scholarship_info = collegeService.esData.fullProfile.scholarship_info;
      if (this.props.enabledFeatures?.includes(FEATURE_MATCH_HUBS_INTERSECT_YOUVISITTOURS_IPEDSCODE)) {
        editData.ipedscode = collegeService.esData.fullProfile.general.field_he_ipedscode;
      }
    } else if (collegeService && collegeService.esDataState === 'LOADED') {
      editData.fullProfile = { ...collegeService.esData.fullProfile };
    }

    switch (activeTabIndex) {
      case menuItems.indexOf(BASIC_INFO_TAB):
        return (
          <React.Fragment>
            {isCamino && <CaminoPreviewPane editData={editData} />}
            {!isCamino && editData &&
              (
                <HubsReact
                  params={{ scid: this.props.scid }}
                  isEditMode
                  editData={editData}
                />
              )}
          </React.Fragment>
        );
      case menuItems.indexOf(INTRO_TAB):
        return (
          <Intro
            toggleUpgradeFormVisibility={this.toggleUpgradeFormVisibility}
          />
        );
      case menuItems.indexOf(MEDIA_TAB):
        return (
          <MediaPage
            toggleUpgradeFormVisibility={this.toggleUpgradeFormVisibility}
          />
        );
      case menuItems.indexOf(LINKS_AND_PROFILES_TAB):
        return (
          <LinksAndProfiles
            toggleUpgradeFormVisibility={this.toggleUpgradeFormVisibility}
          />
        );
      default:
        return <NoContent />;
    }
  };

  render() {
    const {
      showConfirmationModal,
      activeTabIndex,
      isUpgradeFormVisible,
      initialConfirmationStep,
      showEditLogoModal,
      showEditPhotosAndVideosModal,
      showAddLinkModal,
      showAddProfileModal,
      showEditAboutUsModal,
      showErrorModal,
      showNestedMenuType,
      validationErrorList,
      showBasicInfoOopsModal,
      menuItems,
      basicInfoContentType,
    } = this.state;
    const {
      scid,
      logoUpload,
      photoUpload,
      nextLinkOrder,
      linksAndProfilesChanges,
      mediaChanges,
      profilePhotoUpload,
      introChanges,
      isBasicInfoDataLoaded,
      hasBasicInfoChanges,
    } = this.props;
    const hasLinksAndProfilesChanges = get(
      linksAndProfilesChanges,
      'hasRegisteredChanges',
    );
    const hasMediaChanges = get(mediaChanges, 'hasRegisteredChanges');
    const hasIntroChanges = get(introChanges, 'hasRegisteredChanges');
    const panes = [
      {
        menuItem: 'BASIC INFO',
        render: () => (
          <BasicInfoMenu
            isLoaded={isBasicInfoDataLoaded}
            scid={scid}
            onSelectItem={this.handleMenuSelectItem}
            menuType={showNestedMenuType}
          />
        ),
      },
      {
        menuItem: 'INTRO',
        render: () => (
          <IntroMenu
            toggleUpgradeFormVisibility={this.toggleUpgradeFormVisibility}
            onShowEditAboutUsModal={this.onShowEditAboutUsModal}
          />
        ),
      },
      {
        menuItem: 'MEDIA',
        render: () => (
          <MediaMenu
            onShowEditLogoModal={this.onShowEditLogoModal}
            toggleUpgradeFormVisibility={this.toggleUpgradeFormVisibility}
            onShowEditPhotosAndVideosModal={this.onShowEditPhotosAndVideosModal}
          />
        ),
      },
      {
        menuItem: 'LINKS & SPOTLIGHTS',
        render: () => (
          <LinksAndProfilesMenu
            onShowAddLinkModal={this.onShowAddLinkModal}
            toggleUpgradeFormVisibility={this.toggleUpgradeFormVisibility}
            onShowAddProfileModal={this.onShowAddProfileModal}
          />
        ),
      },
    ];
    const contentStyleName = `content-container${basicInfoContentType === CAMINO_CONTENT_TYPE ? ' camino' : ''}`;
    return (
      <div styleName="container">
        <RouteTransitionPrompt
          shouldPromptUser={
            hasMediaChanges || hasLinksAndProfilesChanges || hasIntroChanges || hasBasicInfoChanges
          }
          basicInfoChanges={this.getItemsRequiringApproval()}
          PromptModal={PublishConfirmationModal}
          route={this.props.route}
          onDisregardAction={this.props.resetNonPersistentCollegeProfile}
          onSubmitAction={this.onSubmitModal}
          hasLinksAndProfilesChanges={hasLinksAndProfilesChanges}
          hasMediaChanges={hasMediaChanges}
          hasIntroChanges={hasIntroChanges}
          hasBasicInfoChanges={hasBasicInfoChanges}
        />
        {scid && (
          <EditLogoModal
            scid={scid}
            logoUpload={logoUpload}
            onCloseModal={this.onCloseEditLogoModal}
            openModal={showEditLogoModal}
          />
        )}
        {showEditPhotosAndVideosModal && (
          <EditPhotosAndVideosModal
            photoUpload={photoUpload}
            onCloseModal={this.onCloseEditPhotosAndVideosModal}
            openModal={showEditPhotosAndVideosModal}
          />
        )}
        {showEditAboutUsModal && (
          <EditAboutUsModal
            onCloseModal={this.onCloseEditAboutUsModal}
            openModal={showEditAboutUsModal}
            photoUpload={profilePhotoUpload}
          />
        )}
        {showAddLinkModal && (
          <AddLinkModal
            onCloseModal={this.onCloseAddLinkModal}
            openModal={showAddLinkModal}
            nextLinkOrder={nextLinkOrder}
          />
        )}
        {showAddProfileModal && (
          <AddProfileModal
            onCloseModal={this.onCloseAddProfileModal}
            openModal={showAddProfileModal}
          />
        )}
        {showErrorModal && (
          <ErrorModal
            openModal={showErrorModal}
            onClose={this.onCloseErrorModal}
            onSubmit={this.onSubmitModal}
          />
        )}
        {showConfirmationModal && (
          <PublishConfirmationModal
            open={showConfirmationModal}
            onClose={this.onCloseModal}
            onDisregard={this.handleDisregardMyChanges}
            onSubmit={this.onSubmitModal}
            initialStep={initialConfirmationStep}
            hasLinksAndProfilesChanges={hasLinksAndProfilesChanges}
            hasMediaChanges={hasMediaChanges}
            hasIntroChanges={hasIntroChanges}
            basicInfoChanges={this.getItemsRequiringApproval()}
          />
        )}
        {validationErrorList.length > 0 && <InvalidDataModal errors={validationErrorList} onCancel={this.cancelInvalidDataModal} />}
        {showBasicInfoOopsModal && (
          <BasicInfoOopsModal onCancel={this.cancelBasicInfoOopsModal} onSubmit={this.submitAfterBasicInfoOops} />
        )}
        <div styleName="tabs-container">
          <div
            className={`editor-menu-tabs${isBasicInfoDataLoaded || (menuItems[activeTabIndex] !== BASIC_INFO_TAB) ? '' : ' full-height'}`}
          >
            {showNestedMenuType ? (
              <MenuHeader menuType={showNestedMenuType} onGoback={this.resetMenuAndContent} />
            ) : (
              <React.Fragment>
                <h2>
                  <FormattedMessage {...messages.edit} />
                </h2>
                <p>
                  <FormattedMessage {...messages.editDescription} />
                </p>
              </React.Fragment>
            )}
            <Tab
              menu={{ secondary: true, pointing: true }}
              panes={panes}
              activeIndex={activeTabIndex}
              onTabChange={this.onTabSelection}
            />
          </div>
          <PremiumPublishButton
            onClick={this.showPublishModal}
            activeTabIndex={activeTabIndex}
          />
        </div>
        <div styleName={contentStyleName}>{this.renderContent()}</div>
        {isUpgradeFormVisible && (
          <SubscriptionUpgradeForm
            open
            subscription="editprofile"
            onClose={this.toggleUpgradeFormVisibility}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  linksAndProfilesChanges: get(
    state,
    'nonPersistedCollegeProfile.linksAndProfiles',
  ),
  mediaChanges: get(state, 'nonPersistedCollegeProfile.media'),
  introChanges: get(state, 'nonPersistedCollegeProfile.intro'),
  basicInfo: get(state, 'basicInfo'),
  isBasicInfoDataLoaded: get(state, 'basicInfo.isLoaded'),
  hasBasicInfoChanges: get(state, 'basicInfo.hasRegisteredChanges'),
  nextLinkOrder: get(
    state,
    'nonPersistedCollegeProfile.linksAndProfiles.nextOrder',
  ),
});

export default withEnabledFeatures(connect(
  mapStateToProps,
  {
    resetNonPersistentCollegeProfile,
    resetIntroChangesFlag,
    resetMediaChangesFlag,
    resetLinksAndProfilesChangesFlag,
    initializeCMSData,
  },
)(PremiumMenuComponent));
